import { StringSchema } from 'yup'

export default function rntrc(this: StringSchema, message: string) {
  return this.test('rntrc', message, (value = '') => {
    const onlyNumbers = value.replace(/[^0-9]/g, '')
    const notAllowedPatterns = ['0000', '000', '00', '0']

    return !notAllowedPatterns.some(notAllowedPattern => notAllowedPattern === onlyNumbers)
  })
}
